import { useId } from "react";

export default function PaymentWalletIconMini({
  size = 28,
  active = false,
  title = "Payment",
  ...rest
}) {
  const uid = useId();
  const id = (name) => `${uid}-${name}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      style={{ display: "block" }}
      {...rest}
    >
      <title>{title}</title>

      <defs>
        {/* Outer glow */}
        <radialGradient id={id("rimGlow")} cx="50%" cy="50%" r="50%">
          <stop offset="60%" stopColor="#00081a" stopOpacity="0" />
          <stop offset="90%" stopColor="#FF6DA8" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#5AA8FF" stopOpacity="0.6" />
        </radialGradient>

        {/* Rim stroke */}
        <linearGradient id={id("rimStroke")} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF6DA8" />
          <stop offset="50%" stopColor="#A95CFF" />
          <stop offset="100%" stopColor="#5AA8FF" />
        </linearGradient>

        {/* Face fill */}
        <radialGradient id={id("faceFill")} cx="50%" cy="45%" r="60%">
          <stop offset="0%" stopColor="#0d1020" />
          <stop offset="70%" stopColor="#05060d" />
          <stop offset="100%" stopColor="#000000" />
        </radialGradient>

        {/* Highlight */}
        <radialGradient id={id("rimHighlight")} cx="50%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.55" />
          <stop offset="60%" stopColor="#ffffff" stopOpacity="0.18" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>

        {/* Wallet stroke */}
        <linearGradient id={id("walletStroke")} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF6DA8" />
          <stop offset="40%" stopColor="#ff4fa4" />
          <stop offset="60%" stopColor="#7b4dff" />
          <stop offset="100%" stopColor="#5AA8FF" />
        </linearGradient>

        <filter id={id("glow")} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2.2" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <filter id={id("activeAura")} x="-80%" y="-80%" width="260%" height="260%">
          <feGaussianBlur stdDeviation="6" result="a" />
          <feMerge>
            <feMergeNode in="a" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <filter id={id("spark")} x="-200%" y="-200%" width="400%" height="400%">
          <feGaussianBlur stdDeviation="0.6" />
        </filter>
      </defs>

      {/* Outer rings */}
      <g filter={active ? `url(#${id("activeAura")})` : undefined}>
        <circle cx="32" cy="32" r="30" fill={`url(#${id("rimGlow")})`} />
        <circle
          cx="32"
          cy="32"
          r="30"
          fill="none"
          stroke={`url(#${id("rimStroke")})`}
          strokeWidth="4"
        />
        <circle
          cx="32"
          cy="24"
          r="26"
          fill={`url(#${id("rimHighlight")})`}
          opacity="0.4"
        />
        <circle cx="32" cy="32" r="24" fill={`url(#${id("faceFill")})`} />
        <circle
          cx="32"
          cy="32"
          r="24"
          fill="none"
          stroke="#ffffff"
          strokeOpacity="0.18"
          strokeWidth="1.2"
        />
      </g>

      {/* Wallet icon */}
      <g
        filter={`url(#${id("glow")})`}
        stroke={`url(#${id("walletStroke")})`}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        {/* Wallet body */}
        <rect x="20" y="26" width="28" height="18" rx="4" ry="4" />

        {/* Wallet flap */}
        <path d="M20 30 L48 30" />

        {/* Button */}
        <circle cx="42" cy="35" r="2.4" />
      </g>

      {/* Sparkles */}
      <g opacity="0.9">
        <circle cx="20" cy="22" r="0.8" fill="#FFF" filter={`url(#${id("spark")})`} />
        <circle cx="46" cy="18" r="0.6" fill="#FFF" filter={`url(#${id("spark")})`} />
        <circle cx="48" cy="36" r="0.7" fill="#FFF" filter={`url(#${id("spark")})`} />
        <circle cx="18" cy="40" r="0.5" fill="#FFF" filter={`url(#${id("spark")})`} />
      </g>
    </svg>
  );
}
